import React, {
    useState,
    useRef,
    useEffect,
    useContext,
    useMemo
} from "react";

import "./LoadingReceipt.css";

import { ProcessContext } from "../context/ProcessContext";

import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import QRCode from "react-qr-code";
import Barcode from "react-barcode";

function LoadingReceipt({ onClose }) {

    const { processData } = useContext(ProcessContext);

    console.log("Receipt ProcessData:", processData);
console.log("Receipt Product:", processData.PRODUCT_NAME);
    /* ==========================================================
       LOAD PROCESS DATA
    ========================================================== */

    const loadingMode =
        processData.LOADING_MODE === "truck"
            ? "TRUCK LOADING"
            : processData.LOADING_MODE === "ship"
                ? "BARGE LOADING"
                : "NOT SELECTED";

    const selectedEquipment =
        processData.LOADING_MODE === "truck"
            ? processData.SELECTED_TRUCK
            : processData.SELECTED_BARGE;

    const quantityBBL =
        Number(processData.QUANTITY_BBL || 0);

    const quantityMT =
        quantityBBL * 0.136;

    const quantityLitres =
        quantityBBL * 158.987;

    const accumulatorBBL =
        Number(processData.ACCUMULATOR_BBL || 0);

    const accumulatorLitres =
        accumulatorBBL * 158.987;

    const batchStatus =
        processData.BATCH_STATUS || "READY";

    const startTime =
        processData.LOADING_START || "--";

    const endTime =
        processData.LOADING_END || "--";

    const duration =
        processData.LOADING_DURATION || "--";

    const operator =
        processData.OPERATOR_NAME || "";

    const customer =
        processData.CUSTOMER_NAME || "";

    const vehicleNumber =
        processData.VEHICLE_NUMBER || "";

    const product =
        processData.PRODUCT_NAME || "";

    const company =
        processData.COMPANY_NAME || "";

    const destination =
        processData.DESTINATION || "";

    const transporter =
        processData.TRANSPORTER || "";

    const receiptNumber = useMemo(() => {

        return (
            processData.RECEIPT_NUMBER ||

            `NK-${new Date().getFullYear()}-${Date.now()
                .toString()
                .slice(-6)}`
        );

    }, []);

    const permit =
        processData.LOADING_PERMIT || "";

    const batchNumber =
        processData.PRODUCT_BATCH_NO || "";

    const density =
        processData.PRODUCT_DENSITY || "";

    const api =
        processData.PRODUCT_API || "";

    const temperature =
        processData.PRODUCT_TEMPERATURE || "";

    /* ==========================================================
       CALCULATIONS
    ========================================================== */

    const loadingPercent =
        quantityBBL > 0
            ? (
                (accumulatorBBL / quantityBBL) * 100
            ).toFixed(1)
            : "0.0";

    const variance =
        (quantityBBL - accumulatorBBL).toFixed(2);

    const varianceLitres =
        (quantityLitres - accumulatorLitres).toFixed(0);

    const averageFlow =
        duration === "--"
            ? "--"
            : (
                accumulatorBBL /
                (
                    Math.max(
                        1,
                        (parseFloat(duration) || 1)
                    )
                )
            ).toFixed(2);

    /* ==========================================================
       WINDOW POSITION
    ========================================================== */

    const [position, setPosition] = useState({

        x: window.innerWidth / 2 - 400,

        y: 40

    });

    const [dragging, setDragging] =
        useState(false);

    const offset =
        useRef({ x: 0, y: 0 });

    const receiptRef =
        useRef(null);

    const customerPage =
        useRef(null);

    const internalPage =
        useRef(null);

    /* ==========================================================
       DRAGGING
    ========================================================== */

    const startDrag = (e) => {

        setDragging(true);

        offset.current = {

            x: e.clientX - position.x,

            y: e.clientY - position.y

        };

    };

    useEffect(() => {

        const move = (e) => {

            if (!dragging) return;

            setPosition({

                x: e.clientX - offset.current.x,

                y: e.clientY - offset.current.y

            });

        };

        const stop = () => {

            setDragging(false);

        };

        window.addEventListener(
            "mousemove",
            move
        );

        window.addEventListener(
            "mouseup",
            stop
        );

        return () => {

            window.removeEventListener(
                "mousemove",
                move
            );

            window.removeEventListener(
                "mouseup",
                stop
            );

        };

    }, [
        dragging,
        position.x,
        position.y
    ]);

    /* ==========================================================
       PRINT
    ========================================================== */

    const handlePrint = () => {

    const originalTitle = document.title;

    document.title = receiptNumber;

    const scroll = document.querySelector(".receipt-scroll");

    if (scroll) {

        scroll.style.overflow = "visible";
        scroll.style.height = "auto";

    }

    window.print();

    if (scroll) {

        scroll.style.overflowY = "auto";
        scroll.style.height = "";

    }

    document.title = originalTitle;

};

    /* ==========================================================
       MULTI-PAGE PDF
    ========================================================== */

    const capturePage = async (ref) => {

        const canvas =
            await html2canvas(ref.current, {

                backgroundColor: "#ffffff",

                scale: 3,

                useCORS: true

            });

        return canvas.toDataURL("image/png");

    };

    const handlePDF = async () => {

        const pdf = new jsPDF({

            orientation: "portrait",

            unit: "mm",

            format: "a4"

        });

        const pageWidth = 210;

        const customerImg =
            await capturePage(customerPage);

        pdf.addImage(

            customerImg,

            "PNG",

            0,

            0,

            pageWidth,

            297

        );

        pdf.addPage();

        const internalImg =
            await capturePage(internalPage);

        pdf.addImage(

            internalImg,

            "PNG",

            0,

            0,

            pageWidth,

            297

        );

        pdf.save(

            `${receiptNumber}.pdf`

        );

    };

    return (

        <div
            className="receipt-window"
            style={{
                left: position.x,
                top: position.y
            }}
        >

            {/*=====================================================
            HEADER
            ======================================================*/}

            <div
                className="receipt-header no-print"
                onMouseDown={startDrag}
            >

                <div>

                    NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                </div>

                <button
                    className="receipt-close"
                    onClick={onClose}
                >
                    ✕

                </button>

            </div>


        <div className="receipt-scroll">

            {/*=====================================================
            PAGE 1
            ======================================================*/}

            <div
                ref={customerPage}
                className="receipt-page"
            >

                <div className="customer-stamp">

                    CUSTOMER COPY

                </div>


                {/*=========================================
                COMPANY HEADER
                =========================================*/}

                <div className="receipt-company">

                    <div className="receipt-logo">

                        NK

                    </div>

                    <div className="receipt-company-details">

                        <h1>

                            NK TECH NIGERIA LIMITED

                        </h1>

                        <h2>

                            Industrial DCS & Digital Twin Solution

                        </h2>

                        <h3>

                            OFFICIAL PRODUCT LOADING RECEIPT

                        </h3>

                        <p>

                            Refinery Automation • Tank Farm • Marine Loading • Truck Loading

                        </p>

                        <p>

                            NK Tech Industrial Layout,
                            Yenagoa State,
                            Nigeria

                        </p>

                        <a

                            href="https://nktechhub.com"

                            target="_blank"

                            rel="noreferrer"

                            className="receipt-link"

                        >

                            www.nktechhub.com

                        </a>

                    </div>

                </div>


                <hr />


                {/*=========================================
SUMMARY CARDS
=========================================*/}

                <div className="summary-grid">

                    <div className="summary-card">

                        <div className="summary-title">

                            PRODUCT

                        </div>

                        <div className="summary-value">

                            {product}

                        </div>

                    </div>

                    <div className="summary-card">

                        <div className="summary-title">

                            STATUS

                        </div>

                        <div className="summary-value">

                            {batchStatus}

                        </div>

                    </div>

                    <div className="summary-card">

                        <div className="summary-title">

                            LOADED

                        </div>

                        <div className="summary-value">

                            {accumulatorBBL.toFixed(2)} BBL

                        </div>

                    </div>

                    <div className="summary-card">

                        <div className="summary-title">

                            PROGRESS

                        </div>

                        <div className="summary-value">

                            {loadingPercent} %

                        </div>

                    </div>

                </div>


                <hr />


                {/*=========================================
BARCODE
=========================================*/}

                <div className="barcode-area">

                    <Barcode

                        value={receiptNumber}

                        displayValue={false}

                        height={45}

                    />

                    <div>

                        Receipt No.

                        <strong>

                            {receiptNumber}

                        </strong>

                    </div>

                </div>


                {/*=========================================
CUSTOMER INFORMATION
=========================================*/}

                <h3 className="section-title">

                    CUSTOMER INFORMATION

                </h3>

                <table className="receipt-table">

                    <tbody>

                        <tr>

                            <td>Customer</td>

                            <td>{customer}</td>

                        </tr>

                        <tr>

                            <td>Company</td>

                            <td>{company}</td>

                        </tr>

                        <tr>

                            <td>Driver</td>

                            <td>{operator}</td>

                        </tr>

                        <tr>

                            <td>Vehicle Number</td>

                            <td>{vehicleNumber}</td>

                        </tr>

                        <tr>

                            <td>Transporter</td>

                            <td>{transporter}</td>

                        </tr>

                        <tr>

                            <td>Destination</td>

                            <td>{destination}</td>

                        </tr>

                    </tbody>

                </table>


                {/*=========================================
LOADING INFORMATION
=========================================*/}

                <h3 className="section-title">

                    LOADING INFORMATION

                </h3>

                <table className="receipt-table">

                    <tbody>

                        <tr>

                            <td>Loading Mode</td>

                            <td>{loadingMode}</td>

                        </tr>

                        <tr>

                            <td>Equipment</td>

                            <td>{selectedEquipment}</td>

                        </tr>

                        <tr>

                            <td>Product</td>

                            <td>{product}</td>

                        </tr>

                        <tr>

                            <td>Permit Number</td>

                            <td>{permit}</td>

                        </tr>

                        <tr>

                            <td>Batch Number</td>

                            <td>{batchNumber}</td>

                        </tr>

                        <tr>

                            <td>API Gravity</td>

                            <td>{api}</td>

                        </tr>

                        <tr>

                            <td>Density</td>

                            <td>{density}</td>

                        </tr>

                        <tr>

                            <td>Temperature</td>

                            <td>{temperature} °C</td>

                        </tr>

                    </tbody>

                </table>


                {/*=========================================
QUANTITY SUMMARY
=========================================*/}

                <h3 className="section-title">

                    QUANTITY SUMMARY

                </h3>

                <table className="receipt-table">

                    <tbody>

                        <tr>

                            <td>Requested Quantity</td>

                            <td>{quantityBBL.toLocaleString()} BBL</td>

                        </tr>

                        <tr>

                            <td>Requested Quantity</td>

                            <td>{quantityMT.toFixed(2)} MT</td>

                        </tr>

                        <tr>

                            <td>Requested Quantity</td>

                            <td>{quantityLitres.toLocaleString()} Litres</td>

                        </tr>

                        <tr>

                            <td>Actual Loaded</td>

                            <td>{accumulatorBBL.toFixed(2)} BBL</td>

                        </tr>

                        <tr>

                            <td>Actual Loaded</td>

                            <td>{accumulatorLitres.toLocaleString()} Litres</td>

                        </tr>

                        <tr>

                            <td>Variance</td>

                            <td>{variance} BBL</td>

                        </tr>

                        <tr>

                            <td>Loading Progress</td>

                            <td>{loadingPercent}%</td>

                        </tr>

                    </tbody>

                </table>


                {/*=========================================
TIME SUMMARY
=========================================*/}

                <h3 className="section-title">

                    TIME SUMMARY

                </h3>

                <table className="receipt-table">

                    <tbody>

                        <tr>

                            <td>Loading Started</td>

                            <td>{startTime}</td>

                        </tr>

                        <tr>

                            <td>Loading Completed</td>

                            <td>{endTime}</td>

                        </tr>

                        <tr>

                            <td>Duration</td>

                            <td>{duration}</td>

                        </tr>

                    </tbody>

                </table>


                <div className="receipt-security">

                    <div>

                        <QRCode

                            value={receiptNumber}

                            size={95}

                        />

                    </div>

                    <div className="receipt-disclaimer">

                        This document is electronically generated by the
                        NK Tech Industrial DCS & Digital Twin Solution.
                        Unauthorized alteration invalidates this document.

                    </div>

                </div>


                <div className="receipt-signatures">

                    <div className="signature-box">

                        __________________________

                        <br /><br />

                        Control Room Operator

                    </div>

                    <div className="signature-box">

                        __________________________

                        <br /><br />

                        Loading Supervisor

                    </div>

                    <div className="signature-box">

                        __________________________

                        <br /><br />

                        Customer Representative

                    </div>

                </div>


                <div className="receipt-page-footer">

                    Generated electronically by

                    <strong>

                        NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                    </strong>

                    <br />

                    Page 1 of 2

                </div>

            </div>

            {/*=====================================================
            END OF PAGE 1
            PART 3 CONTINUES FROM HERE
            ======================================================*/}



            {/*=====================================================
            PAGE 2 - INTERNAL OPERATIONS COPY
            ======================================================*/}


            <div
                ref={internalPage}
                className="receipt-page internal-page"
            >


                <div className="internal-stamp">

                    INTERNAL OPERATIONS COPY

                </div>



                {/*=========================================
                INTERNAL HEADER
                =========================================*/}


                <div className="receipt-company">


                    <div className="receipt-logo">

                        NK

                    </div>


                    <div className="receipt-company-details">


                        <h1>

                            NK TECH NIGERIA LIMITED

                        </h1>


                        <h2>

                            Industrial DCS & Digital Twin Solution

                        </h2>


                        <h3>

                            LOADING OPERATIONS AUDIT REPORT

                        </h3>


                        <p>

                            CONTROL ROOM / TERMINAL OPERATIONS DOCUMENT

                        </p>


                        <p>

                            Generated from Digital Twin Simulation Platform

                        </p>


                    </div>


                </div>



                <hr />



                {/*=========================================
                BATCH AUDIT SUMMARY
                =========================================*/}


                <h3 className="section-title">

                    BATCH AUDIT SUMMARY

                </h3>



                <table className="receipt-table">

                    <tbody>


                        <tr>

                            <td>Receipt Number</td>

                            <td>{receiptNumber}</td>

                        </tr>


                        <tr>

                            <td>Batch Status</td>

                            <td>

                                <strong>

                                    {batchStatus}

                                </strong>

                            </td>

                        </tr>



                        <tr>

                            <td>Loading Mode</td>

                            <td>{loadingMode}</td>

                        </tr>



                        <tr>

                            <td>Loading Equipment</td>

                            <td>{selectedEquipment}</td>

                        </tr>



                        <tr>

                            <td>Product Loaded</td>

                            <td>{product}</td>

                        </tr>



                        <tr>

                            <td>Product Batch Number</td>

                            <td>{batchNumber}</td>

                        </tr>



                        <tr>

                            <td>Loading Permit</td>

                            <td>{permit}</td>

                        </tr>


                    </tbody>

                </table>





                {/*=========================================
                PROCESS PERFORMANCE
                =========================================*/}


                <h3 className="section-title">

                    PROCESS PERFORMANCE

                </h3>



                <table className="receipt-table">


                    <tbody>



                        <tr>

                            <td>Requested Batch Quantity</td>

                            <td>

                                {quantityBBL.toLocaleString()} BBL

                            </td>

                        </tr>



                        <tr>

                            <td>Actual Transfer Quantity</td>

                            <td>

                                {accumulatorBBL.toFixed(2)} BBL

                            </td>

                        </tr>




                        <tr>

                            <td>Remaining Quantity</td>

                            <td>

                                {variance} BBL

                            </td>

                        </tr>




                        <tr>

                            <td>Loading Completion</td>

                            <td>

                                {loadingPercent} %

                            </td>

                        </tr>




                        <tr>

                            <td>Average Loading Rate</td>

                            <td>

                                {averageFlow} BBL/min

                            </td>

                        </tr>




                        <tr>

                            <td>Total Loaded Volume</td>

                            <td>

                                {accumulatorLitres.toLocaleString()} Litres

                            </td>

                        </tr>


                    </tbody>


                </table>






                {/*=========================================
                PRODUCT QUALITY INFORMATION
                =========================================*/}


                <h3 className="section-title">

                    PRODUCT QUALITY DATA

                </h3>



                <table className="receipt-table">

                    <tbody>


                        <tr>

                            <td>Product Name</td>

                            <td>{product}</td>

                        </tr>



                        <tr>

                            <td>API Gravity</td>

                            <td>{api}</td>

                        </tr>



                        <tr>

                            <td>Density</td>

                            <td>{density}</td>

                        </tr>



                        <tr>

                            <td>Loading Temperature</td>

                            <td>{temperature} °C</td>

                        </tr>



                        <tr>

                            <td>Product Batch</td>

                            <td>{batchNumber}</td>

                        </tr>


                    </tbody>


                </table>






                {/*=========================================
                OPERATION TIMELINE
                =========================================*/}



                <h3 className="section-title">

                    OPERATION TIMELINE

                </h3>



                <table className="receipt-table">


                    <tbody>


                        <tr>

                            <td>Start Time</td>

                            <td>{startTime}</td>

                        </tr>



                        <tr>

                            <td>Completion Time</td>

                            <td>{endTime}</td>

                        </tr>



                        <tr>

                            <td>Total Duration</td>

                            <td>{duration}</td>

                        </tr>




                        <tr>

                            <td>Operator</td>

                            <td>{operator}</td>

                        </tr>


                    </tbody>


                </table>







                {/*=========================================
                OPERATION REMARKS
                =========================================*/}



                <h3 className="section-title">

                    OPERATION REMARKS

                </h3>


                <div className="remarks-box">


                    Loading batch generated through NK Tech Industrial DCS
                    and Digital Twin monitoring system.


                    <br /><br />


                    Status verification:

                    {batchStatus}



                    <br /><br />


                    No unauthorized modification permitted.


                </div>







                {/*=========================================
                INTERNAL VERIFICATION
                =========================================*/}



                <div className="receipt-security">


                    <div>


                        <strong>

                            SYSTEM VERIFICATION

                        </strong>


                        <div className="qr-placeholder">


                            <QRCode

                                value={JSON.stringify({

                                    receipt: receiptNumber,

                                    batch: batchNumber,

                                    product,

                                    quantity: accumulatorBBL,

                                    status: batchStatus

                                })}

                                size={120}

                            />


                        </div>


                    </div>




                    <div className="receipt-disclaimer">


                        This copy is intended strictly for NK Tech
                        internal operational records.


                        It contains simulated process information
                        generated from the Industrial DCS and Digital Twin
                        environment.


                    </div>



                </div>







                {/*=========================================
                APPROVAL SECTION
                =========================================*/}



                <h3 className="section-title">

                    AUTHORIZATION

                </h3>



                <div className="approval-grid">



                    <div className="signature-box">


                        __________________________

                        <br /><br />


                        Control Room Operator


                    </div>




                    <div className="signature-box">


                        __________________________

                        <br /><br />


                        Shift Supervisor


                    </div>




                    <div className="signature-box">


                        __________________________

                        <br /><br />


                        Operations Manager


                    </div>




                </div>







                <div className="receipt-page-footer">


                    INTERNAL OPERATIONS COPY


                    <br />


                    Generated by:


                    <strong>

                        NK TECH INDUSTRIAL DCS & DIGITAL TWIN SOLUTION

                    </strong>


                    <br />


                    Page 2 of 2


                </div>



            </div>

        </div>

            {/*=====================================================
            WINDOW FOOTER (NOT INCLUDED IN PDF)
            ======================================================*/}

            <div className="receipt-footer no-print">

                <button
                    className="receipt-btn print"
                    onClick={handlePrint}
                >
                    🖨 PRINT
                </button>

                <button
                    className="receipt-btn pdf"
                    onClick={handlePDF}
                >
                    📄 DOWNLOAD PDF
                </button>

                <button
                    className="receipt-btn close"
                    onClick={onClose}
                >
                    ✖ CLOSE
                </button>

            </div>

        </div>

    );

}

export default LoadingReceipt;